export default "__VITE_ASSET__92fc1090__"